import Header from "../../Landing/Header/Header";
import Footer from "../../Landing/Footer/Footer";
import { Link } from "react-router-dom";
import icon02 from "../../../screenassets/images/cta/02.png";
import icon04 from "../../../screenassets/images/feature/04.svg";
import icon05 from "../../../screenassets/images/feature/05.svg";
import icon06 from "../../../screenassets/images/feature/06.svg";
import { FaArrowRightLong } from "react-icons/fa6";
import Icons from "./Icons";



export default function Feature() {
    return (
        <>
            {/* Header Section */}
            <Header />

            <div className="rts-bread-crumb-area bg_image">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb-inne">
                                <div className="title-area">
                                    <h1 className="bread-title">Know Our Features</h1>
                                    <div className="inner-wrapper">
                                        <Link to="/">Home</Link>/
                                        <Link to="#" className="active">Feature</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="rts-case-area rts-section-gap">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="title-conter-area">
                                <h2 className="title">
                                    Generate Step-by-Step Solutions with <br />
                                    Your Favorite Tools
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row g-5 mt--10">
                        <div className="col-lg-4">

                            <div className="single-use-case">
                                <div className=""> 
                                    <Icons image={require("../../../screenassets/images/img/maths.png")} />
                                </div>
                                <h5 className="title">Numerical Master</h5>
                                <p className="disc">
                                    For Physics, Chemistry, and Math numericals, get complete workings, formulas, and units explained.
                                    From “CHSE physics numericals solution verified” to “CBSE Class 10 past paper solution step by step”, every answer builds exam confidence.
                                </p>
                                <Link to="/signin" className="more-case-btn">Explore Numericals <i className="fa-solid fa-arrow-right"></i></Link>
                            </div>

                        </div>
                        <div className="col-lg-4">

                            <div className="single-use-case">
                                <div className="">
                                    <Icons image={require("../../../screenassets/images/img/help.png")} />
                                </div>
                                <h5 className="title">Concept Helper</h5>
                                <p className="disc">
                                    Struggling to recall a definition or theory?
                                    StudentGPT breaks complex Science, Geography, or History concepts into simple, easy-to-learn notes — perfect for quick revision.
                                </p>
                                <Link to="/signin" className="more-case-btn">View Concepts <i className="fa-solid fa-arrow-right"></i></Link>
                            </div>

                        </div>
                        <div className="col-lg-4">

                            <div className="single-use-case">
                                <div className="">
                                    <Icons image={require("../../../screenassets/images/img/social-care.png")} />
                                </div>
                                <h5 className="title">Board-Style English Support</h5>
                                <p className="disc">
                                    Master grammar, comprehension, writing, and literature-based answers crafted for your board’s exam pattern.
                                    Works for “Hindi medium board-style solutions” and “Marathi medium grammar practice”.
                                </p>
                                <Link to="/signin" className="more-case-btn">Practice English <i className="fa-solid fa-arrow-right"></i></Link>
                            </div>
                        </div>
                        <div className="col-lg-4">

                            <div className="single-use-case">
                                <div className="">
                                    <Icons image={require("../../../screenassets/images/img/pencil.png")} />
                                </div>
                                <h5 className="title">Smart Revision Notes</h5>
                                <p className="disc">
                                    Condensed, one-page revision sheets for all subjects — from Math formulas to Biology diagrams — verified by toppers and educators.
                                    Available in Odia, Hindi, Marathi, Bengali and English.
                                </p>
                                <Link to="/signin" className="more-case-btn">View Notes <i className="fa-solid fa-arrow-right"></i></Link>
                            </div>

                        </div>
                        <div className="col-lg-4">

                            <div className="single-use-case">
                                <div className="">
                                    <Icons image={require("../../../screenassets/images/img/exam-time.png")} />
                                </div>
                                <h5 className="title">Exam Booster Tests</h5>
                                <p className="disc">
                                    Test your readiness with auto-generated practice papers and quizzes based on your syllabus and board.
                                    Track your score instantly with AI feedback and topic-wise insights.
                                </p>
                                <Link to="/signin" className="more-case-btn" >Start Practice Test <i className="fa-solid fa-arrow-right"></i></Link>
                            </div>

                        </div>
                        <div className="col-lg-4">

                            <div className="single-use-case">
                                <div className="">
                                    <Icons image={require("../../../screenassets/images/img/innovator.png")} />
                                </div>
                                <h5 className="title">Instant Doubt Solver</h5>
                                <p className="disc">
                                    Take a photo of your question — get instant verified steps and solutions for homework, numericals, or theory answers.
                                    Perfect for last-minute help before exams.
                                </p>
                                <Link to="/signin" className="more-case-btn" >Upload Question <i className="fa-solid fa-arrow-right"></i></Link>
                            </div>

                        </div>
                        <div className="col-lg-4">

                            <div className="single-use-case">
                                <div className="">
                                    <Icons image={require("../../../screenassets/images/img/math-formula.png")} />
                                </div>
                                <h5 className="title">Formula Finder</h5>
                                <p className="disc">
                                    ever get stuck searching for the right formula again.
                                    StudentGPT instantly identifies and explains Math, Physics, and Chemistry formulas — complete with units, derivations, and example problems.
                                    Perfect for “BSE Odisha Class 10 math step-by-step (Odia)” and “WBCHSE physics formula list (Bengali)”.
                                </p>
                                <Link to="/signin" className="more-case-btn" >Open Formula Finder <i className="fa-solid fa-arrow-right"></i></Link>
                            </div>

                        </div>
                        <div className="col-lg-4">

                            <div className="single-use-case">
                                <div className="">
                                    <Icons image={require("../../../screenassets/images/img/paper.png")} />
                                </div>
                                <h5 className="title">Past Paper Pro</h5>
                                <p className="disc">
                                    Access previous years’ board papers and solved answers in your medium — Bengali, Odia, Hindi, Marathi, or English.
                                    Each solution follows board-style steps to help you understand how marks are awarded.
                                    Great for “CBSE Class 10 past paper solution step by step” and “CHSE verified physics numericals.”
                                </p>
                                <Link to="/signin" className="more-case-btn" >View Past Papers <i className="fa-solid fa-arrow-right"></i></Link>
                            </div>

                        </div>
                        <div className="col-lg-4">

                            <div className="single-use-case">
                                <div className="">
                                    <Icons image={require("../../../screenassets/images/img/languages.png")} />
                                </div>
                                <h5 className="title">Language Switch Assist</h5>
                                <p className="disc">
                                    Study comfortably in your own language. Instantly switch between Bengali, Odia, Hindi, Marathi, and English for any question or explanation — no retyping needed.
                                    Ideal for bilingual students preparing across different boards.
                                </p>
                                <Link to="/signin" className="more-case-btn"> Try Language Assist <i className="fa-solid fa-arrow-right"></i> </Link>
                            </div>

                        </div>
                    </div>
                </div>
            </div>




            <div className="feature-area-start rts-section-gapBottom">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="title-left-feature">
                                <h2 className="title">
                                    How StudentGPT Makes <br />
                                    Study Smarter
                                </h2>
                                <p className="disc">
                                    Here’s how easy it is to generate verified, step-by-step board solutions in your language using StudentGPT.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row mt--60">
                        <div className="col-lg-12">

                            <div className="single-feature-area-main-inner">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="feature-content-inner">
                                            <h3 className="title"><span>Step 01:</span> Topic Selection</h3>
                                            <p className="disc">
                                                Choose your subject and board — whether it’s WBBSE Class 10 Math (Bengali), CHSE Physics (Odia), or CBSE Science (English).
                                                Our AI understands board patterns and ensures 100% syllabus-matched content for accurate preparation.
                                            </p>
                                            <Link to="/signin" className="rts-btn btn-primary">Select Your Subject  <FaArrowRightLong /></Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="thumbnail-feature">
                                            <img src={icon04} alt="feature" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="single-feature-area-main-inner">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="thumbnail-feature">
                                            <img src={icon05} alt="feature" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="feature-content-inner pl--120">
                                            <h3 className="title">
                                                <span>Step 02:</span> Input Instructions
                                            </h3>
                                            <p className="disc">
                                                Upload a photo of your question, paste text, or type manually.
                                                StudentGPT automatically detects your language, class, and board, then provides detailed, step-by-step explanations — no translation confusion or formatting errors.
                                            </p>
                                            <Link to="/signin" className="rts-btn btn-primary">Upload Your Question <FaArrowRightLong /></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="single-feature-area-main-inner">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="feature-content-inner">
                                            <h3 className="title">
                                                <span>Step 03:</span> Get Step-by-Step Verified Solutions
                                            </h3>
                                            <p className="disc">
                                                Receive instant, teacher-verified answers crafted to your board’s marking pattern.
                                                Every solution includes reasoning, formulas, and complete working steps to ensure full marks in exams.
                                            </p>
                                            <Link to="/signin" className="rts-btn btn-primary">Get My Verified Solution <FaArrowRightLong /></Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="thumbnail-feature">
                                            <img src={icon06} alt="feature" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>










            <div className="rts-cta-area rts-section-gapBottom bg_faq">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="cta-main-wrapper bg_image">
                                <div className="left">
                                    <h3 className="title">
                                        Ready to Simplify Your <br />
                                        Studies?
                                    </h3>
                                    <Link to="/signin" class="rts-btn btn-primary" >Started Now</Link>
                                </div>
                                <div className="right">
                                    <img src={icon02} alt="cta-area" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* Footer Section */}
            <Footer />

        </>
    )
}
